import React from "react"
import styled from "styled-components"

import { Flex } from "components/box"
import { PlainLink } from "components/text"
import { CurrentUser } from "graphql/smart-queries/user"
import config from "config/api"

const Container = styled(Flex)`
  justify-content: center;
  text-align: center;
  width: 100%;
  background-color: ${props => props.theme.colors.salmon};
`

type ImpersonationBarProps = { currentUser: CurrentUser }

function ImpersonationBar({ currentUser }: ImpersonationBarProps) {
  return (
    <Container py={2}>
      {`You are logged in as: ${currentUser.fullName} with email: ${currentUser.email}`}
      <PlainLink color="#ff0000" href={`${config.adminMonolithHost}/abandon_user_disguise`}>
        Stop impersonating ✖
      </PlainLink>
    </Container>
  )
}

export default ImpersonationBar
